import { Link } from "react-router-dom"
import styled from "styled-components"

export const ModuleContainer = styled.div`
    display: grid;
  grid-template-columns: 16rem minmax(0, 1fr);
    /* Prevent unexpected page scroll bleed in desktop, allow inner areas to manage scroll */
    overflow-y: hidden;
    min-height: 0; /* allow children to size/scroll inside grid */

    /* Mobile: stack sidebar on top and allow page scroll */
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      grid-template-rows: auto 1fr;
      overflow-y: auto;
    }
`

export const Sidebar = styled.div`
  background: rgb(110,90,60);
  display: flex;
  flex-direction: column;
  padding-top: 2rem;
  gap: 1rem;

  h1 {
    color: #fff;
    font-size: 1.45rem;
    line-height: 1.2;
    margin: 0 1rem 0.5rem;
    text-align: center;
  }

  /* Mobile: turn into a horizontal, scrollable pill nav */
  @media (max-width: 768px) {
    flex-direction: row;
    align-items: center;
    padding: .5rem;
    gap: .5rem;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* firefox */
    &::-webkit-scrollbar { display: none; } /* webkit */

    h1 {
      font-size: 1rem;
      margin: 0 .5rem 0 0;
      white-space: nowrap;
    }
  }

  /* Hide the title on very narrow phones to prioritize nav pills */
  @media (max-width: 420px) {
    h1 { display: none; }
  }
`

export const NavItem = styled(Link)`
  background: rgb(12, 23, 56);
  border-radius: 4rem;
  padding: .25rem .5rem;
  height: 3rem;
  margin: 0 .5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-transform: uppercase;
  text-decoration: none;

  /* Ensure labels don't wrap and make pills denser on small screens */
  white-space: nowrap;
  font-size: 0.9rem;

  @media (max-width: 768px) {
    height: 2.5rem;
    margin: 0 .25rem;
    padding: .25rem .75rem;
    font-size: 0.8rem;
  }
`

export const Container = styled.div`
  padding: .5rem;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;

  /* cuando este en un dispositivo pequeño no hacen overflow en y */
  @media (max-width: 768px) {
    overflow-y: auto;
  }
`

export const ActionsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ModuleTitle = styled.h1`
  text-align: center;
`